import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useBookingConfig } from '@/lib/BookingConfigContext';
import { EXPERIENCE_DATA } from './bookingDefaults';

// Re-export for backward compatibility with any existing imports
export { EXPERIENCE_DATA, ADULT_RIG_DATA, RIG_DATA } from './bookingDefaults';

export default function ExperienceCard({ type, selected, onSelect, index = 0 }) {
  const { experiences } = useBookingConfig();
  const exp = experiences[type] || EXPERIENCE_DATA[type];
  if (!exp) return null;

  const features = (exp.specs || []).filter((s) => !/minutes of drive time/i.test(s) && !/^drive time/i.test(s));

  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      onClick={() => onSelect(type)}
      className={`w-full h-full text-left p-6 flex flex-col transition-all duration-300 relative overflow-hidden border ${
        selected ? 'bg-primary/10 border-primary/40' : 'bg-primary/5 border-primary/30 hover:border-primary hover:bg-primary/10'
      }`}
    >
      {selected && <div className="absolute top-0 left-0 right-0 h-[2px] bg-primary" />}

      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 pr-4">
          <span className="text-primary text-[10px] font-bold tracking-widest mb-1 block">{exp.tag}</span>
          <h3 className="text-white font-black text-sm uppercase leading-tight min-h-[2.5rem]">{exp.name}</h3>
        </div>
        <div className={`w-5 h-5 border-2 flex items-center justify-center shrink-0 mt-1 transition-all ${
          selected ? 'border-primary bg-primary' : 'border-white/20'
        }`}>
          {selected && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
        </div>
      </div>

      <div className="mb-5 h-16 flex items-end">
        <p className="text-primary font-black text-2xl leading-none">
          £{exp.price}
          <span className="text-white/30 text-sm font-normal block mt-1">per session of {exp.duration_minutes || 50} mins</span>
        </p>
      </div>

      <div className="space-y-2.5 flex-1">
        {features.map((spec) => (
          <div key={spec} className="flex items-start gap-2 text-sm text-white/50">
            <div className="w-1 h-1 bg-primary rounded-full shrink-0 mt-2" />
            <span>{spec}</span>
          </div>
        ))}
      </div>

    </motion.button>
  );
}